import { StyledFrenchFlag } from './LanguageFlag.styled';

export default function FrenchFlag() {
  return <StyledFrenchFlag />;
}
